export class FilterWarehouseXRolRequest {
  buildingCode: number;
  subDivision: number;
  user: string;
  language: String;
  jobTitle: String;
}
